const TYPE = 'recovr.detail.saleVehicleLink';
function getName() {
  return 'Sale Vehicle Link';
}
function create(objectType) {
  return {
    type: TYPE
  };
}
export default {
  create,
  TYPE,
  getName
};